import { InjectionToken } from '@angular/core';
import { LogLevel } from '../logger/log-levels.enum';
import { TransporterConfig } from './transporter-config.model';
import { TransportTemplate } from './transporter-template.model';

/**
 * Transporter Injection Token
 */
export const TransporterToken = new InjectionToken<TransportTemplate>('Transporter');

/**
 * Individual transporter option
 */
export interface Transporter<T> {
  template: TransportTemplate<T>;
  config?: TransporterConfig;
  write(payload: T, level: LogLevel): void;
}
